// extracted by mini-css-extract-plugin
export default {"body":"PanelStack-module__body___25Hfq","panel":"PanelStack-module__panel___3XXc-"};